export interface Paymentprofile {
  id: number;
  name: string;
  post_ordering: boolean;
  salary_deduction: boolean;
  external_id: string;
  available_options_for_change: string;
  order_prepayment_solution_id?: number;
  order_erp_solution_id?: number;


//   order_erp_solution_id?: number;
//   order_prepayment_solution_id?: number;
  order_prepayment_solutions?: string;
  order_prepayment_solution?: PrepaymentSolution | null;
  order_erp_solutions?: string;
  order_erp_solution?: ErpSolution | null;
}

export function newPaymentprofile(): Paymentprofile {
  return {
    id: 0,
    name: "",
    post_ordering: false,
    salary_deduction: false,
    external_id: "",
    available_options_for_change: "",
  }
}

export interface PrepaymentSolution {
    id: number,
    name: string,
    url: string,
    token1: string,
    token2: string,
    username: string,
    client_id: string,
    // sys_payment_solution_id?: SysPaymentSolution | null,
  }

  export function newPrepaymentSolution(): PrepaymentSolution {
    return {
      id: 0,
      name: "",
      url: "",
      token1: "",
      token2: "",
      username: "",
      client_id: "",
    }
  }
  
export interface ErpSolution {
    id: number,
    name: string,
    url: string,
    token1: string,
    token2: string,
    username: string,
    client_id: string,
    // sys_erp_solution_id?: SysErpSolution | null,
  }


  export function newErpSolution(): ErpSolution {
    return {
      id: 0,
      name: "",
      url: "",
      token1: "",
      token2: "",
      username: "",
      client_id: "",
    }
  }

  export interface SysPaymentSolution {
    id: number;
    name: string;
    url: string;
  }

  export interface SysErpSolution {
    id: number;
    name: string;
    url: string;
  }